<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" >{{ isBranchRiskManager ? "SET" : "VIEW" }} CONCENTRATION FOR {{ traderData.firstName }} {{ traderData.lastName }}</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
                <div>
                    <div class="form-group row" >
                        <label for="user" class="col-sm-2 col-form-label text-uppercase">Capital Invested:</label>
                        <div class="col-sm-3">
                            <!-- <currency-input v-model="maxCapital" class="form-control capital-w"/>  -->
                           <!-- <input v-debounce:300ms="() => validateConcentration('MAX_CAPITAL',maxCapital,'')"  v-if="isBranchRiskManager" type="number" class="form-control" v-model="maxCapital"/> -->
                            <currency-input
                                v-model="maxCapital"
                                class="form-control"
                                currency="USD"
                                :distraction-free="{'hideNegligibleDecimalDigits' : 'true'}"
                                v-debounce:300ms="() => validateConcentration('MAX_CAPITAL',maxCapital,'')"
                            />
                            
                           <span class="position-absolute mt-2" v-if="!isBranchRiskManager">{{maxCapital}}</span>
                        </div>
                        <label for="user" class="col-sm-3 col-form-label">CUSIP MAX QTY (000's):</label>
                        <div class="col-sm-3">
                           <!-- <input v-debounce:300ms="() => validateConcentration('CUSIP',cusipConcentration,'')" v-if="isBranchRiskManager" type="number" class="form-control" v-model="cusipConcentration" /> -->
                           <currency-input
                                    v-model="cusipConcentration"
                                    v-if="isBranchRiskManager"
                                    :precision="0"
                                    class="form-control"
                                    v-debounce:300ms="() => validateConcentration('CUSIP',cusipConcentration,'')"
                                />
                           <span class="position-absolute mt-2" v-if="!isBranchRiskManager">{{formatNumber(cusipConcentration)}}</span>

                        </div>
                    </div>
                </div>
                <div><hr></div>
                <div class="d-flex bd-highlight mt-3">
                    <div>
                        <h4 style="color: #0087D4;" v-if="isBranchRiskManager">SET STATE</h4>
                        <h4 style="color: #0087D4;" v-if="!isBranchRiskManager"> STATE</h4>
                    </div>
                </div>
                <div v-if="isBranchRiskManager">
                    <div class="form-group row" >
                        <label for="user" class="col-sm-2 col-form-label">STATE:</label >
                        <div class="col-sm-3">
                            <select class="form-control"  v-model="stateConcentrationKey" >
                                <option v-for="state in stateConstants" :key="state.short">{{ state.short }}</option>
                            </select>
                        </div>
                        <label for="user" class="col-sm-2 col-form-label">VALUE(%):</label>
                        <div class="col-sm-3">
                            <input type="number" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control" v-model="stateConcentrationValue"/>
                        </div>
                        <button :disabled="!isBranchRiskManager || !stateConcentrationValue || !stateConcentrationKey || loading" @click="checkStateConcentrationValid()" type="button" class="btn btn-primary">ADD</button>

                    </div>
                </div>
                <div class="table-responsive" style="max-height:300px;">
                    <div v-if="loading" class="loader">
                        <img src="@/assets/img/loader.svg" alt="" />
                    </div>
                    <table
                        class="table align-items-center table-flush table-hover bidtbl"
                    >
                        <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">STATE</th>
                            <th scope="col" class="sort text-center">VALUE(%)</th>
                            <th scope="col" class="sort text-center" v-if="isBranchRiskManager">ACTION</th>
                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                            <tr v-if="stateConcentration.length == 0">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="(stateData,index) in stateConcentration" :key="stateData.concentration">
                                <td class="text-center">{{ stateData.concentration }}</td>
                                <td class="text-center">
                                    <input v-debounce:300ms="() => checkStateConcentrationValidOnEdit(stateData.concentration,stateData.concentrationValue)"  v-if="isBranchRiskManager" type="number" v-model="stateData.concentrationValue" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control mx-auto input-width">
                                    <span v-if="!isBranchRiskManager">{{ stateData.concentrationValue }}</span>
                                </td>
                                <td v-if="isBranchRiskManager">
                                    <span
                                        @click="deleteConcentration(index,'STATE')" class="cursor-pointer">
                                       <i style="color: #d65537;" class="fa fa-times"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                </div>
                <div><hr></div>
                <div  class="d-flex bd-highlight mt-3">
                    <div>
                        <h4 style="color: #0087D4;" v-if="isBranchRiskManager">SET RATING</h4>
                        <h4 style="color: #0087D4;" v-if="!isBranchRiskManager"> RATING</h4>
                    </div>
                </div>
                <div v-if="isBranchRiskManager">
                    <div class="form-group row ml-3"  v-if="branchRatingConcentration.length ==  0" >
                        <label for="user" class="mt-2">RATING FROM:</label >
                        <div class="col-sm-2">
                            <select class="form-control" @change="checkRatingRangeisValid()"  v-model="ratingConcentrationKeyFrom" >
                                <option v-for="rating in spRatingConstants" :key="rating">{{ rating }}</option>
                            </select>
                         </div>
                         <label for="user" class="mt-2">RATING TO:</label >
                        <div class="col-sm-2">
                            <select class="form-control" @change="checkRatingRangeisValid()"  v-model="ratingConcentrationKeyTo" >
                                <option v-for="rating in spRatingConstants" :key="rating">{{ rating }}</option>
                            </select>
                         </div>
                        <label for="user" class="mt-2">VALUE(%):</label>
                        <div class="col-sm-3">
                            <input type="number" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control" v-model="ratingConcentrationValue"/>
                        </div>
                        <button :disabled="!isBranchRiskManager || !ratingConcentrationValue || !ratingConcentrationKeyFrom || !ratingConcentrationKeyTo || loading" @click="checkRatingConcentrationValid()" type="button" class="btn btn-primary">ADD</button>

                    </div>
                    <div class="form-group row"  v-if="branchRatingConcentration.length > 0" >
                        <label for="user" class="col-sm-1 col-form-label">RATING</label >
                        <div class="col-sm-3">
                            <select class="form-control"  v-model="branchRating" @change="setRatingFromTo()">
                                <option v-for="(rating,i) in branchRatingConcentration" :key="i" :value="rating">{{rating[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ rating[rating.length - 1] }}</option>
                            </select>
                         </div>
                         <label for="user" class="col-sm-1 col-form-label">VALUE(%):</label>
                        <div class="col-sm-3">
                            <input type="number" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control" v-model="ratingConcentrationValue"/>
                        </div>
                        <button :disabled="!isBranchRiskManager || !ratingConcentrationValue || !ratingConcentrationKeyFrom || !ratingConcentrationKeyTo || loading" @click="checkRatingConcentrationValid()" type="button" class="btn btn-primary">ADD</button>
                    </div>
                </div>
                <div class="table-responsive" style="max-height:300px;">
                    <div v-if="loading" class="loader">
                        <img src="@/assets/img/loader.svg" alt="" />
                    </div>
                    <table
                        class="table align-items-center table-flush table-hover bidtbl"
                    >
                        <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">RATING</th>
                            <th scope="col" class="sort text-center">VALUE(%)</th>
                            <th scope="col" class="sort text-center" v-if="isBranchRiskManager">ACTION</th>

                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                            <tr v-if="ratingConcentration.length == 0">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="(ratingData,index) in ratingConcentration" :key="ratingData.concentration">
                                <td class="text-center" v-if="ratingData.concentrationList">{{ ratingData.concentrationList[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ ratingData.concentrationList[ratingData.concentrationList.length - 1] }}</td>
                                <td class="text-center">
                                    <input v-debounce:300ms="() => checkRatingConcentrationValidOnEdit(ratingData.concentrationList,ratingData.concentrationValue,index)" v-if="isBranchRiskManager" type="number" oninput="javascript: if (this.value > 100) this.value = 100;" v-model="ratingData.concentrationValue"  class="form-control mx-auto input-width">
                                    <span v-if="!isBranchRiskManager">{{ ratingData.concentrationValue }}</span>
                                </td>
                                <td v-if="isBranchRiskManager">
                                    <span
                                        @click="deleteConcentration(index,'RATING')" class="cursor-pointer">
                                       <i style="color: #d65537;" class="fa fa-times"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                </div>             
              <div class="modal-footer bid">
                  <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                  <button :disabled="loading" v-if="isBranchRiskManager" type="button" class="btn btn-primary" @click="saveConcetration()">SAVE CONCENTRATION</button>
              </div>
          </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
//import authService from "@/authService";
import config from "@/config";
import stateConstants from "@/stateConstants";
import spRatingConstants from "@/spRatingConstants";

  export default {
      name: 'moneyLineEditmodal',
      components :{
          
      },
      props: ['traderData','selectedOrgToken','branchData'],
      data() {
          return {
            loading : false,
            maxCapital : 0,
            cusipConcentration : 0,
            stateConcentrationValue : "",
            stateConcentrationKey: "",
            stateConstants: stateConstants,
            spRatingConstants:spRatingConstants,
            stateConcentration : [],
            ratingConcentration : [],
            ratingConcentrationValue : "",
            ratingConcentrationKey: "",
            ratingConcentrationKeyFrom: "",
            ratingConcentrationKeyTo: "",
            branchRating: "",
            isBranchRiskManager : false,
            branchRatingConcentration : []
          };
      },
      methods: { 
        validateConcentration(type,value,concentration) {
            if(!value) return
            this.loading = true;
            const auth = {
                headers: { "org-token": this.selectedOrgToken },
            };
            let urlParams = `?concentrationType=${type}&concentrationValue=${value}&traderId=${this.traderData.id}&traderMaxCapital=${this.maxCapital}`;
            if(concentration && type != 'RATING'){
                urlParams += `&concentration=${concentration}`
            }
            if(concentration  && type == 'RATING'){
                urlParams += `&concentrationList=${concentration}`
            }
            return this.$http
                .get(config.baseUrlAutoBidder + "/compliance/validate-concentration"+urlParams, auth)
                .then((result) => {
                    if(!result.data.isValid){
                        if(type == 'MAX_CAPITAL'){
                            this.$alert("The Branch Capital exceeds the limit set by the Broker Dealer.","","error");
                            this.maxCapital = this.traderData.maxCapitalConcList.length ? this.traderData.maxCapitalConcList[0].concentrationValueDolAmt : 0;
                        }
                        if(type == 'CUSIP'){
                            this.$alert("Cusip max quantity exceeds the limit set by the Broker Dealer.","","error");
                            this.cusipConcentration = this.traderData.cusipConcList.length ? this.traderData.cusipConcList[0].concentrationValue : 0;
                        }
                        if(type == 'STATE'){
                            this.$alert("State Concentration exceeds the limit set by the Broker Dealer.","","error");
                        }
                        if(type == 'RATING'){
                            this.$alert("Rating Concentration exceeds the limit set by the Broker Dealer.","","error");
                        }

                    }
                    this.loading = false;                        
                    return result.data.isValid;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        deleteConcentration(index,mode){
            const message = `Are you sure you want to delete?`;
            this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                if(mode == 'STATE'){
                    this.stateConcentration.splice(index,1)
                }
                if(mode == 'RATING'){
                    this.ratingConcentration.splice(index,1)
                }
            })
        },
        checkStateConcentrationValid(){
            if(!this.maxCapital){
                this.$alert("Capital Invested is required.","","error");
                return false
            }
            if(!this.isConcentrationExist("STATE",this.stateConcentrationKey)){
                this.validateConcentration("STATE",this.stateConcentrationValue,this.stateConcentrationKey).then((data) => {
                    if(data)
                    this.addToStateList();
                })
            }
            
        },
        checkStateConcentrationValidOnEdit(state,value){
            this.validateConcentration("STATE",value,state).then((data) => {
                if(!data){
                    this.stateConcentration.forEach((stateData) => {
                        if(stateData.concentration == state){
                            stateData.concentrationValue = 0
                        }
                    })
                }    
            })
        },
        setRatingFromTo(){
            this.ratingConcentrationKeyFrom = this.branchRating[0];
            this.ratingConcentrationKeyTo = this.branchRating[this.branchRating.length - 1];
           

        },
        checkRatingConcentrationValid(){
            if(!this.maxCapital){
                this.$alert("Capital Invested is required.","","error");
                return false
            }
            if(!this.checkRatingOverlapped()){
                this.validateConcentration("RATING",this.ratingConcentrationValue,this.getRangeOfRatings(this.ratingConcentrationKeyFrom,this.ratingConcentrationKeyTo)).then((data) => {
                    if(data)
                    this.addToRatingList();
                })
            }
            
            
            
        },
        checkRatingRangeisValid(){
            var stringArry = this.spRatingConstants;
            if(this.ratingConcentrationKeyFrom && this.ratingConcentrationKeyTo){
                var startIndex = stringArry.indexOf(this.ratingConcentrationKeyFrom);
                var endIndex = stringArry.indexOf(this.ratingConcentrationKeyTo);
                if(startIndex <= endIndex) {
                    console.log('Selected range is valid');
                } else {
                    this.$alert('From Rating should be lower than to rating',"","error");
                    this.ratingConcentrationKeyFrom = "";
                    this.ratingConcentrationKeyTo = "";
                }
            }

        },
        checkRatingOverlapped(){
            let savedRatings = [];
            this.ratingConcentration.forEach((rating) => {
                savedRatings.push(...rating.concentrationList) 
            });
            let ratingChoosed =  this.getRangeOfRatings(this.ratingConcentrationKeyFrom,this.ratingConcentrationKeyTo);
            console.log(savedRatings,ratingChoosed)

            let exists = savedRatings.some(element => ratingChoosed.includes(element));

            if(exists){
                this.$alert("Rating has already been added.","","error")
                return exists;

            }else{
                return exists;
            }
        },
        checkRatingConcentrationValidOnEdit(rating,value,index){
            this.validateConcentration("RATING",value,rating).then((data) => {
                if(!data){
                    this.ratingConcentration.forEach((ratingData,i) => {
                        if(i == index){
                            ratingData.concentrationValue = 0
                        }
                    })
                }    
            })
        },
        addToStateList(){
            this.stateConcentration.push({
                "concentrationType":"STATE",
                "concentration":this.stateConcentrationKey,
                "concentrationValue":this.stateConcentrationValue
            });
            this.stateConcentrationKey = "";
            this.stateConcentrationValue = "";
        },
        addToRatingList(){
            this.ratingConcentration.push({
                "concentrationType":"RATING",
                // "concentration":this.ratingConcentrationKey,
                "concentrationValue":this.ratingConcentrationValue,
                "concentrationList" : this.getRangeOfRatings(this.ratingConcentrationKeyFrom,this.ratingConcentrationKeyTo)

            });
            this.ratingConcentrationKey = "";
            this.ratingConcentrationValue = "";
        },
        getRangeOfRatings(datafrom,datato){
            console.log(datafrom,datato)
            var stringArry = this.spRatingConstants
            var startIndex = stringArry.indexOf(datafrom);
            var endIndex = stringArry.indexOf(datato);
            var range = [];
            if(startIndex > endIndex){
                // swap the values
                var temp = startIndex;
                startIndex = endIndex;
                endIndex = temp;
            }
            if(datafrom && datato){
                range = stringArry.slice(startIndex, endIndex + 1);
            }else{
                range = []
            }
            return range;
            },
        isConcentrationExist(type,value){
            var isValid = false
            if(type == 'STATE'){
                this.stateConcentration.forEach((state) => {
                    if(state.concentration == value){
                        this.$alert("State has already been added.","","error")
                        isValid = true
                    }
                })
            }
            if(type == 'RATING'){
                this.ratingConcentration.forEach((rating) => {
                    if(rating.concentration == value){
                        this.$alert("Rating has already been added.","","error")
                        isValid = true
                    }
                })
            }

            return isValid;

        },
        saveConcetration(){
            let dataToSend = { 
                "data":[], 
                "cognitoSub":this.traderData.cognitoSub,
            }
            dataToSend.data = [...this.ratingConcentration, ...this.stateConcentration];
            dataToSend.data.push({
                "concentrationType":"CUSIP",
                "concentration":null,
                "concentrationValue":this.cusipConcentration
            })
            dataToSend.data.unshift({
                "concentrationType":"MAX_CAPITAL",
                "concentration":null,
                "concentrationValue":this.maxCapital
            })
            let traderSavedRatingConc  = this.ratingConcentration.map(item => item.concentrationList);
            console.log(traderSavedRatingConc)
            console.log(this.branchRatingConcentration)
            try {
                this.checkArrayElementsExistence(traderSavedRatingConc, this.branchRatingConcentration);
                this.loading = true;
                const auth = {
                    headers: { "org-token": this.selectedOrgToken },
                };
                this.$http
                    .post(config.baseUrlAutoBidder + "/autobidder/add-concentration", dataToSend, auth)
                    .then(() => {
                        //this.setTraderCapital()
                        this.loading = false;
                        this.$emit('close');               


                    })
                    .catch((e) => {
                        console.log(e);
                    });
            
            } catch (error) {
                console.log(error);
                this.$alert(error,"","error")
                
            }

        },
        checkArrayElementsExistence(array1, array2) {
            
            // Check if Brocker dealer value is empty
            if (array2.length === 0) {
                return true; // Return success
            }
            array1.forEach(subArray1 => {
                subArray1.forEach(element => {
                    if (!array2.some(subArray2 => subArray2.includes(element))) {
                        throw new Error(`Rating '${element}' is not available in broker dealer rating concentration`);
                    }
                });
            });
        },
        setTraderCapital() {
            let dataToSend = {
                "cognitoSub":this.traderData.cognitoSub,
                "maxCapital":this.maxCapital
            }
            const auth = {
                headers: { "org-token": this.selectedOrgToken },
            };
            this.$http
                .post(config.baseUrlAutoBidder + "/autobidder/add-max-capital", dataToSend, auth)
                .then(() => {
                    this.loading = false;
                    this.$emit('close');               
                })
                .catch((e) => {
                console.log(e);
                });
        },
      },
      created(){
        this.maxCapital =  this.traderData.maxCapitalConcList.length ? this.traderData.maxCapitalConcList[0].concentrationValueDolAmt : 0
        this.stateConcentration = this.traderData.stateConcList.map(item => ({
                concentrationType: item.concentrationType,
                concentration:  item.concentration,
                concentrationValue: item.concentrationValue
            }));
        this.ratingConcentration = this.traderData.creditRatingConcList.map(item => ({
                concentrationType: item.concentrationType,
                // concentration: item.concentration,
                concentrationValue: item.concentrationValue,
                concentrationList : item.concentrationList

            }));
        if(this.traderData.cusipConcList.length)
        this.cusipConcentration = this.traderData.cusipConcList[0].concentrationValue;

        this.branchRatingConcentration = this.branchData.creditRatingConcList.map(item => item.concentrationList);
        console.log(this.branchRatingConcentration)

      },
      mounted() {
        this.$cognitoAuth.getIdToken((err, result) => {
            if (err) {
                console.log("accessToken is not found", err);
            } else {
                console.log(err);
               
                this.accessToken = result;
                this.$cognitoAuth.getUserGroup((err, role) => {
                if (err) {
                    console.log("accessToken is not found", err);
                } else {
                    var roleArray = role.map(item => {
                        return  item.split("-")[1];
                    })
                    this.isBranchRiskManager =  roleArray.includes("RiskManager") ? this.isBranchRiskManager = true : this.isBranchRiskManager = false;
                }
                });
            }
        });
    },
  };
  </script>
  <style scoped>
    hr{
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
    .col-form-label {
        font-size: 12px;
    }
    .input-width {
        width: 100px; /* Adjust the width as needed */
    }
    .input-d i.fa-dollar-sign {
        position: absolute;
        top: 35%;
        left: 10px;
        z-index: 9999;
        color: inherit;
       
    }
</style>